import Loadable from 'react-loadable'

const AppsLanding = Loadable({
    loader: () => import(/* webpackChunkName: "appsLanding" */ './apps'),
    loading: () => null,
})

const AppsLandingRoute = ({
    location: {
        state: { apps, app },
    },
}) => <AppsLanding apps={apps} currentApp={app} />

export default AppsLandingRoute
